import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { useForm } from "react-hook-form";
import { InputForm, SelectFormm } from "../../components/molecules/forms/index";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import DetailDataSkeleton from "../../components/template/skeleton/DetailDataSkeleton";
import Swal from "sweetalert2";
import {
  useCreateDetokenizeMutation,
  useGetPolicyNameMutation,
} from "../../store/feature/service/tokenization";
import tokenize from "../../utils/validation/tokenize";

const Detokenize = () => {
  // REGION: INIT VARIABLES
  const location = useLocation();
  const { pathname } = location;
  const [optKey, setOptKey] = useState([]);
  const editFgroup = pathname.includes("edit");

  const [getPolicy, { isSuccess, isError, data, error }] =
    useGetPolicyNameMutation();
  const [
    createDetokenize,
    {
      isSuccess: successDetokenize,
      isError: errorDetokenize,
      data: dataDetokenize,
      error: dataErrorDetokenize,
      isLoading: loadingDetokenize,
    },
  ] = useCreateDetokenizeMutation();

  // const { data: dataMaskPolicy } = useGetMaskPolicyDetailQuery(idParam);
  // REGION: INIT FORM DATA
  const {
    control,
    reset,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm<{
    policyName: string;
    plaintext: string;
    result: string;
  }>({
    reValidateMode: "onChange",
    resolver: yupResolver(tokenize),
    defaultValues: {
      policyName: "",
      plaintext: "",
      result: "",
    },
  });

  // REGION: SET FORM DATA
  useEffect(() => {
    if (data) {
      setOptKey(
        data?.token_policies?.map((item: any) => ({
          label: item.name,
          value: item.name,
        }))
      );
    }
  }, [data]);

  // REGION: DISPATCH SUCCESS EVENT
  useEffect(() => {
    getPolicy({ pagesize: 100 });
  }, []);

  useEffect(() => {
    if (dataDetokenize) {
      setValue("result", dataDetokenize?.value);
    }
  }, [dataDetokenize]);

  // REGION: DISPATCH INSERT & UPDATE DATA
  const onSubmit = (e: any) => {
    let tempVar = {
      policyName: e.policyName,
      tokenData: e.plaintext,
    };
    console.log("tempVar ===> ", tempVar);
    //TO DO be continue here
    createDetokenize(tempVar);
  };

  useEffect(() => {
    if (errorDetokenize) {
      const dataError: any = dataErrorDetokenize;
      // console.log('wkwkwk ===> ', dataErrorSign?.data)
      Swal.fire({
        icon: "error",
        title: "Error Create",
        showCancelButton: false,
        confirmButtonText: "OK",
        confirmButtonColor: "#051438",
        text: dataError?.data?.error,
      });
    }
  }, [errorDetokenize]);

  // REGION: RETURN TSX
  return (
    <DetailDataSkeleton
      isLoading={false}
      isLoadingEvent={loadingDetokenize}
      inputCount={6}
      titleWidth={"350px"}
    >
      <Box component="form" onSubmit={handleSubmit(onSubmit)} paddingY="20px">
        <Typography variant="h3" fontFamily="Open Sans" mb={3}>
          Detokenize
        </Typography>
        <SelectFormm
          name="policyName"
          label="Policy Name"
          defaultValue={0}
          options={optKey}
          placeholder="Please Select"
          disabled={false}
          isLoading={false}
          control={control}
          errors={errors}
          required
        />
        <InputForm
          name="plaintext"
          label="Detokenized Data"
          placeholder="Type Plaintext Data"
          disabled={false}
          isLoading={false}
          control={control}
          errors={errors}
          maxLength={1000}
          required
        />

        <Stack
          spacing={2}
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
        >
          <Button variant="contained" type="submit">
            Detokenize
          </Button>
        </Stack>

        <Typography variant="h4" sx={{ fontWeight: "bold" }}>
          Result
        </Typography>
        <InputForm
          name="result"
          placeholder="Type Input Value"
          disabled={editFgroup}
          isLoading={false}
          control={control}
          errors={errors}
          maxLength={1000}
          required
        />
      </Box>
    </DetailDataSkeleton>
  );
};

export default Detokenize;
